import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthBypassService {
    private skipAuthCheck = false;

    setSkip(value: boolean) {
        this.skipAuthCheck = value;
    }

    shouldSkip(): boolean {
        return this.skipAuthCheck;
    }
}
